/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from 'theme-ui';
import TextInput from './TextInput';

/**
 *
 * @param {{
 *  onChange?: import('react').ChangeEventHandler;
 *  variant?: import('./inputVariants').InputVariant;
 *  placeholder?: string;
 *  rows?: number;
 *  [x: string]: any;
 * }} props
 * @returns
 */
export default function Input({ onChange, placeholder, rows = 3, ...rest }) {
  return (
    <TextInput
      as="textarea"
      onChange={onChange}
      placeholder={placeholder}
      rows={rows}
      {...rest}
    />
  );
}
